import React, { FC, ReactNode } from "react";
import { useSelector } from "react-redux";

interface AuthPageProps {
    title: ReactNode;
    // Round badge above the title, e.g. a tick on a success page.
    icon?: ReactNode;
    iconTone?: "ok" | "bad" | "primary";
    // Hide the vendor logo (e.g. when an icon tells the story).
    hideLogo?: boolean;
    children?: ReactNode;
    // Buttons at the bottom, full width and stacked.
    actions?: ReactNode;
    // Shown under the card (e.g. the app version on the log in page).
    below?: ReactNode;
}

// Stand-alone account pages (log in, forgot / reset password, account confirmation, ...): one card in the middle of
// the page with the vendor logo, the same design as the client portal's log in dialog and account pages.
const AuthPage: FC<AuthPageProps> = ({ title, icon, iconTone = "primary", hideLogo = false, children, actions, below }) => {
    const logoUrl = useSelector((state: any) => state.settings?.settings?.VendorLogoUrl);

    return (
        <main className="pb-auth-page">
            <div className="pb-auth-card pb-auth">
                {!hideLogo && logoUrl && <img className="pb-auth-logo" src={logoUrl} alt="" />}
                {icon && <div className={"pb-auth-icon pb-auth-icon--" + iconTone}>{icon}</div>}
                <h1 className="pb-auth-title">{title}</h1>
                {children && <div className="pb-auth-body">{children}</div>}
                {actions && <div className="pb-auth-actions">{actions}</div>}
            </div>
            {below && <div className="pb-auth-below">{below}</div>}
        </main>
    );
};

export default AuthPage;
